import { Component, OnInit } from '@angular/core';
import {NgbModal, ModalDismissReasons, NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import { StorageModel } from './../../models/storage.model';

@Component({
  selector: 'app-modal-add-image',
  templateUrl: './modal-add-image.component.html',
  styles: []
})
export class ModalAddImageComponent implements OnInit {

  tipo: number;
  clave: string;

  private _storageModel = new StorageModel;
  selectedFile : File;

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
  }

  onFileSelected(event){
    this.selectedFile = event.target.files[0];
  }

  agregarImagen(){
    this.activeModal.close('Guardado datos');
    if(this.selectedFile)
    {
      this._storageModel.uploadImageProfile(this.selectedFile, '/bills/', this.selectedFile.name).then(val => {
        var ruta = val;
        this._storageModel.addImage(this.clave, ruta, this.tipo);
      });
    }
  }

}
